@import "../../../../global/gx-ide-mixins.scss";
@import "../../../../../node_modules/@genexus/mercury/dist/assets/scss/helpers.scss";

@include box-sizing;

gx-ide-list-selector-item {
  display: block;
  max-width: 100%;
  display: flex;

  &:hover {
    .label {
      background-color: var(--color-accent-item-hover);
      cursor: pointer;
    }
    input:checked + .label {
      border-color: var(--color-accent-item-hover);
    }
  }

  &:active {
    .label {
      background-color: transparent;
      color: var(--color-text-primary-pressed);
    }
  }
}

/*readonly*/
gx-ide-list-selector-item[readonly]:not([readonly="false"]) {
  .label {
    pointer-events: none;
    background-color: transparent;
  }
}
/*ellipsis*/
gx-ide-list-selector-item[ellipsis]:not([ellipsis="false"]) {
  .label {
    &__description {
      @include ellipsis;
    }
  }
}

gx-ide-list-selector-item input {
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0;

  &:focus + .label {
    @include focus-outline();
  }
  &:checked + .label {
    background-color: var(--color-accent-item-selected);
  }
  &:checked:hover + .label {
    color: var(--color-accent-primary-on-hover);
  }
}

/*label-wrapper*/
gx-ide-list-selector-item .label {
  width: 100%;
  border-radius: 4px;
}

/*label*/
gx-ide-list-selector-item .label {
  &__index {
  }
  &__wrapper {
    display: flex;
    min-height: 28px; /*this prevents height difference between items that have icons and items that do not*/
    align-items: center;
    gap: var(--spacing-gap-m);
    padding: 4px 8px;
    width: 100%;
  }
  &__description {
    flex: 1;
    display: flex;
    align-items: center;
    gap: var(--spacing-gap-m);
  }
}

/*no border*/
gx-ide-list-selector-item[no-border] {
  border-block-start: none;
}

/*universal slot*/
gx-ide-list-selector-item .label__universal-slot {
  display: flex;
  align-items: center;
  justify-content: center;
}
